import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfImageTag } from "@swagger/typescript-fetch-goflyer";

export const useImageTagOptions = () => {
  const [imageTagOptionList, setImageTagOptionList] =
    useState<GfImageTag[]>();

  const fetchImageTags = useCallback(async () => {
    try {
      const response =
        await adminApiService.getManyBaseGfImageTagAdminControllerGfImageTag();
      setImageTagOptionList(response.data);
    } catch (error) {
      console.error("Error fetching image tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchImageTags();
  }, [fetchImageTags]);

  return { imageTagOptionList, fetchImageTags };
};
